import React from 'react';
import Banner from './Banner';
import SimplicityFAQ from './SimplicityFAQ';
import Contact from './Contact';
import WhyPartner from './WhyPartner';
import WhoWePartnerWith from './WhoWePartnerWith';

import { Helmet } from 'react-helmet-async';

const PartnerWithUs = () => {
  return (
    <>
      <Helmet>
        <title>Partner with Aerobott — Drone Training, Technology and Distribution Partnerships in India</title>
        <meta name="description" content="Partner with Aerobott — India's leading drone company. We offer partnerships for educational institutes, agri-businesses, infrastructure firms, and drone distributors. Apply today." />
      </Helmet>
      {/* Font styling (font loaded globally in index.html or _document.js) */}
      <style>{`
        .font-raleway {
          font-family: 'Raleway', sans-serif;
        }
      `}</style>

      <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-black text-white font-raleway">
        <Banner />

        {/* Who We Partner With Section */}
        <WhoWePartnerWith />

        {/* Partnership Form Section */}
        <section id="contact">
          <Contact />
        </section>

        {/* Why Partner with Us Section */}
        <section id="why-partner">
          <WhyPartner />
        </section>

        {/* FAQ Section */}
        <SimplicityFAQ />
      </div>
    </>
  );
};

export default PartnerWithUs;
